import React, { useEffect, useState } from 'react';
import Service from '../Dashboard/services/Service';
import './Medication.scss';

const STATUS_LABELS = {
  pending: 'Pending',
  mdi_review: 'MDI Review',
  mdi_approved: 'MDI Approved',
  mdi_rejected: 'MDI Rejected',
  sent_to_pharmacy: 'Sent to Pharmacy',
  shipped: 'Shipped',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
};

const MedicationStatus = () => {
  const [medications, setMedications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMedicationStatus();
  }, []);

  const fetchMedicationStatus = async () => {
    try {
      setLoading(true);
      const response = await Service.getMedicationStatus();
      setMedications([response.data]);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch medication status');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="medication-status-container">
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading medication status...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="medication-status-container">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="medication-status-container">
      <h2>Medication Status</h2>
      <div className="table-responsive">
        <table className="medication-table">
          <thead>
            <tr>
              <th>#Sr.No</th>
              <th>Medication Name</th>
              <th>Medication Status</th>
            </tr>
          </thead>
          <tbody>
            {medications.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center no-data">
                  No medication records found.
                </td>
              </tr>
            ) : (
              medications.map((med, index) => (
                <tr key={med.voucher_id}>
                  <td className="serial-col">{String(index + 1).padStart(3, '0')}</td>
                  <td>{med.medication_name}</td>
                  <td>
                    <span className={`status-badge med-${med.medication_status?.replace(/_/g, '-')}`}>
                      {STATUS_LABELS[med.medication_status] || med.medication_status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MedicationStatus;
